import CreatePatientAlert from './CreatePatientAlert'

export default CreatePatientAlert
